let config = {
	isVanish: false,
  isLogin: false,
  // type: 'login'
  // type: 'invite',
  type: 'newInvite'
}

export default config


// WEBPACK FOOTER //
// ./src/assets/js/config.js